<template>
  <div class="scroll-section">
    <div class="get-in-touch">
      <div class="git-heading">
        <h1><strong>{{ $t('footer.heading') }}</strong></h1>
        <h3>{{ $t('footer.sub_heading') }}</h3>
      </div>
      <div class="contact-line" v-html="$t('footer.contact')"></div>
    </div>
    <div class="builder">
      <img :src="builderSvg">
    </div>
    <div class="offices">
      <div class="container">
        <div class="columns">
          <div class="column is-one-quarter animate">
            <h5 v-html="$t('footer.ods_header')"></h5>
            <div class="maps-container">
              <img src="../.././assets/office-ods-optimized.jpg">
            </div>
            <address v-html="$t('footer.ods_address')"></address>
          </div>
          <div class="column is-one-quarter animate">
            <h5 v-html="$t('footer.cph_header')"></h5>
            <div class="maps-container">
              <img src="../.././assets/office-cph-optimized.jpg">
            </div>
            <address v-html="$t('footer.cph_address')"></address>
          </div>
          <div class="column is-one-quarter animate">
            <h5 v-html="$t('footer.aal_header')"></h5>
            <div class="maps-container">
              <img src="../.././assets/office-aal.png">
            </div>
            <address v-html="$t('footer.aal_address')"></address>
          </div>
          <div class="column is-one-quarter animate">
            <h5 v-html="$t('footer.de_header')"></h5>
            <div class="maps-container">
              <img src="../.././assets/office-de-updated.jpg">
            </div>
            <address v-html="$t('footer.de_address')"></address>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column is-full business-info animate">
            <h5 v-html="$t('footer.bi_header')"></h5>
            <dl>
              <template v-for="n in 4">
                <div class="business-info-col">
                  <dt v-html="$t('footer.business_info[' + (n - 1) + '].title')" :key="n + 'title'"></dt>
                  <dd v-html="$t('footer.business_info[' + (n - 1) + '].value')" :key="n + 'value'"></dd>
                </div>
              </template>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="the-bottom">
      <h2 style="margin-bottom: 15px">ONLINECITY.IO</h2>
      <a href="https://auth.onlinecity.io/docs/pdp-en.pdf" style="color: white; text-decoration: underline"
        target="_blank">Privacy
        Policy</a>
    </div>
  </div>
</template>

<script>
import builder from '../.././assets/builder-optimized.png';
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'site-footer',
  data() {
    return {
      exclude_from_nav: false,
      nav_title: 'our_offices',
      builderSvg: builder
    }
  },
  mounted() {
    this.hideElements()
    this.setActiveSection(this.$options._componentTag)
    this.runSectionAnimations()
  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
        }
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 200) && this.scroll_pos < ((this.elHeight) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection'
    ]),
    hideElements() {
      if (window.ieLegacy()) {
        return;
      }
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
    },
    runSectionAnimations() {
      if (this.animationsInit) return
      if (window.ieLegacy()) {
        return;
      }
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.staggerTo(elements, 0.3, {
        autoAlpha: 1
      }, 0.1)
      TweenMax.staggerFromTo(elements, 1, {
        y: 80
      }, {
        y: 0,
        ease: Power2.easeInOut
      }, 0.2)
      this.animationsInit = true
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-section {
  padding-top: 10px;
  background-color: #001d6d;
  position: relative;
  z-index: 2;
  overflow: visible;
  margin-top: -2px;
}

.column {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
}
</style>

<style lang="scss">
.get-in-touch {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .git-heading {
    text-align: center;
    position: relative;

    >h1 {
      font-size: 3.2rem;
      text-transform: uppercase;
      margin-bottom: 4.5rem;

      strong {
        color: white;
      }

      @media screen and (max-width: 480px) {
        font-size: 2rem;
      }
    }

    >h3 {
      display: inline-block;
      position: absolute;
      right: -104px;
      top: 30px;
      font-family: 'angelique_roseregular';
      font-size: 3.6rem;
      color: #ff7c4e;

      @media screen and (max-width: 480px) {
        font-size: 2.5rem;
        right: -20px;
      }
    }
  }

  .contact-line {
    text-transform: uppercase;
    margin-bottom: 4.5rem;

    @media screen and (max-width: 480px) {
      padding: 0 2rem;
    }

    >h5 {
      font-size: 1.5rem;

      @media screen and (max-width: 480px) {
        font-size: 1.2rem;
      }

      strong {
        color: white;
      }
    }

    a {
      color: #ff7c4e;

      &:hover {
        color: #ff7c4e;
        text-decoration: underline;
      }
    }
  }
}

.offices {
  width: 100%;
  padding: 4.5rem 0;
  padding-bottom: 20px;

  background-color: #0e1d54;

  @media screen and (max-width: 480px) {
    padding: 2.5rem 1.5rem;
  }

  h5 {
    font-size: 1.5rem;
    line-height: 1.5rem;
    color: white;
    text-transform: uppercase;
    margin-bottom: 2rem;

    strong {
      color: white;
    }

    @media screen and (max-width: 768px) {
      margin-bottom: .5rem;
    }
  }

  address {
    color: white;
    font-style: normal;

    p>strong {
      color: white;
    }

    @media screen and (max-width: 768px) {
      margin-bottom: 2rem;
    }
  }
}

.business-info {
  color: #adb1bf;

  width: 75% !important;
  max-width: 750px;
  text-align: center;
  margin: 50px auto 0 auto;

  @media screen and (max-width: 768px) {
    margin-top: 25px;
  }

  h5 {
    color: #adb1bf;

    strong {
      color: #adb1bf;
    }
  }

  //. &:nth-child(2) {
  .business-info-col {

    margin-bottom: 1em;

    @media screen and (min-width: 769px) {
      width: 50%;
      float: left;
      clear: none;
    }

    &:nth-child(1) {}

    &:nth-child(2) {}

    &:nth-child(3) {}

    &:nth-child(4) {}
  }

  dl {

    @media screen and (max-width: 768px) {
      margin-top: 25px;
    }

    dt {
      font-weight: 500;
    }

    dd {
      //margin-bottom: 1rem;
    }

  }
}

.maps-container {
  overflow: hidden;
  position: relative;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    margin-bottom: .2rem;
  }
}

.the-bottom {
  width: 100%;
  padding: 3rem 0;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 1.5rem 0;
  }

  h2 {
    font-weight: 100;
    font-size: 2rem;
    color: white;
    text-transform: uppercase;
    font-family: "Gotham Rounded SSm A", "Gotham Rounded SSm B";

    @media screen and (max-width: 768px) {
      font-size: 1.3rem;
    }

    strong {
      color: white;
    }
  }
}

.builder {
  position: absolute;
  width: 570px;
  top: -498px;
  z-index: 9;
  left: 8%;

  @media screen and (max-width: 1300px) {
    width: 390px;
    top: -290px;
  }

  @media screen and (max-width: 960px) {
    left: 3%;
  }

  @media screen and (max-width: 860px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/Footer.vue